import { LockKeyhole, LockOpen } from "lucide-react";
import React from "react";

import {
  IgAvatar,
  IgButton,
  IgLink,
  IgTypography,
} from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";

export const ControlGroupLockedEmptyState = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleUnlock = () => {
    void dispatch(ExperienceBuilderAction.trackControlGroupUnlocked());
    dispatch(ExperienceBuilderAction.setControlGroupLocked(false));
  };

  const handleLearnMore = () => {
    // TODO: Hook up to documentation link once available
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2.5}
      sx={{ flex: 1, px: 2.5, py: 8, textAlign: "center" }}
    >
      <IgAvatar
        variant="circular"
        sx={{
          backgroundColor: theme.igPrimitives.gray[900],
          width: 50,
          height: 50,
        }}
      >
        <LockKeyhole size={24} color={theme.palette.text.secondary} />
      </IgAvatar>
      <Stack spacing={1} alignItems="center" maxWidth={292}>
        <IgTypography fontWeight={600}>Control group is locked</IgTypography>
        <IgTypography variant="body2" color={theme.palette.text.secondary}>
          This represents your live baseline and is kept unchanged for accurate
          measurement.
        </IgTypography>
      </Stack>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <IgLink fontWeight={600} onClick={handleLearnMore}>
          Learn more
        </IgLink>
        <IgButton
          variant="outlined"
          color="secondary"
          startIcon={<LockOpen size={16} />}
          onClick={handleUnlock}
        >
          Unlock control group
        </IgButton>
      </Stack>
    </Stack>
  );
};
